var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container" },
    [
      !_vm.isKpmgUser
        ? _c(
            "div",
            { staticClass: "button-content" },
            [
              _c(
                "el-button",
                {
                  staticClass: "wl-green",
                  attrs: { icon: "el-icon-star-off" },
                  on: { click: _vm.goToMyCourse },
                },
                [_vm._v(_vm._s(_vm.$t("kee_my")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-carousel",
        { staticClass: "course-carousel", attrs: { trigger: "click" } },
        _vm._l(_vm.homeRotateList, function (item) {
          return _c("el-carousel-item", { key: item.courseId }, [
            _c("img", {
              staticClass: "imageItem",
              attrs: {
                src: "data:image/png;base64," + item.imageByte,
                alt: "",
              },
              on: {
                click: function ($event) {
                  return _vm.goDetail(item)
                },
              },
            }),
          ])
        }),
        1
      ),
      _c(
        "div",
        { staticClass: "wl-client-container kpmg" },
        [
          _vm._l(_vm.menu, function (item, index) {
            return [
              _c(
                "div",
                { staticClass: "wl-client-item", class: "item" + (index + 1) },
                [
                  _vm.newTag[item.newTag]
                    ? _c("div", { staticClass: "iconNew" })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "menu_item_info",
                      on: {
                        click: function ($event) {
                          return _vm.clickCourseList(item)
                        },
                      },
                    },
                    [
                      _c("img", { attrs: { src: item.src } }),
                      _c(
                        "div",
                        {
                          class: [
                            _vm.$i18n.locale === "en" ? "en-fontSize" : "",
                          ],
                          style: "color: " + _vm.getFontColor(index),
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t(item.name)) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }